export default __webpack_public_path__ + "static/Signerica_Fat-e682d9bdcfa935317be8779e6478d053.svg";